// FAQ.jsx
import React from "react";
import Layout from "../../components/user/Layout";

const FrequentlyAskedQuestion = () => {
  return (
    <Layout>
      <div className="faq-page  py-22 ps-40 pe-40">
        <h2 className="d-flex justify-content-center fw-bold">Frequently Asked Questions (FAQ)</h2>
        <p className="faq-intro">
          Applicable to Power Trading Company and its digital platforms including{" "}
          <a href="https://www.powergroups.in" target="_blank" rel="noopener noreferrer">
            www.powergroups.in
          </a>
        </p>

        <section className="faq-list">
          <ol>
            <li>
              <strong>What does Power Trading Company do?</strong>
              <p>
                Power Trading Company is engaged in the supply and trading of cement, steel, and a wide range of construction materials for residential, commercial, and infrastructure projects across India.
              </p>
            </li>
            <li>
              <strong>What products do we offer?</strong>
              <p>We deal in:</p>
              <ul>
                <li>Cement (all major brands and grades)</li>
                <li>Steel (TMT bars, structural steel, sections)</li>
                <li>Construction materials such as aggregates, sand, and all related building supplies</li>
              </ul>
              <p><em>Product availability may vary by location.</em></p>
            </li>
            <li>
              <strong>Who can place orders?</strong>
              <p>
                Our services are primarily B2B and B2C focused, catering to builders, contractors, developers, institutions, and bulk buyers. Individual customers may also place orders subject to minimum quantity requirements.
              </p>
            </li>
            <li>
              <strong>How can I place an order?</strong>
              <p>Orders can be placed through:</p>
              <ul>
                <li>Our mobile application</li>
                <li>Our official website{" "}
                  <a href="https://www.powergroups.in" target="_blank" rel="noopener noreferrer">
                    www.powergroups.in
                  </a>
                </li>
                <li>Direct coordination with our sales team</li>
              </ul>
            </li>
            <li>
              <strong>Are prices fixed or negotiable?</strong>
              <p>
                Prices depend on market conditions, quantity, brand, and delivery location. Bulk orders may be eligible for special pricing.
              </p>
            </li>
            <li>
              <strong>Do prices include GST?</strong>
              <p>
                GST is applied as per Indian tax laws and will be clearly mentioned in invoices.
              </p>
            </li>
            <li>
              <strong>What are the payment options?</strong>
              <p>We accept payments through:</p>
              <ul>
                <li>UPI</li>
                <li>Net banking</li>
                <li>Debit/Credit cards</li>
                <li>Other approved digital payment methods</li>
              </ul>
              <p><em>Cash or credit terms may be available for approved customers.</em></p>
            </li>
            <li>
              <strong>What is the delivery timeline?</strong>
              <p>
                Delivery timelines depend on product type, order quantity, and delivery location. Estimated delivery dates are shared at the time of order confirmation.
              </p>
            </li>
            <li>
              <strong>Do you provide site delivery?</strong>
              <p>
                Yes, we deliver materials directly to the construction site, subject to accessibility and logistics feasibility.
              </p>
            </li>
            <li>
              <strong>Can I cancel the order?</strong>
              <p>
                Orders can be cancelled before dispatch. Once dispatched, cancellations are generally not permitted due to the nature of construction materials.
              </p>
            </li>
            <li>
              <strong>What is your return or refund policy?</strong>
              <p>
                Construction materials are non-returnable once delivered and accepted. Refunds are applicable only for damaged or incorrect materials, subject to verification.
              </p>
            </li>
            <li>
              <strong>How do you ensure material quality?</strong>
              <p>
                We source materials from trusted manufacturers and authorized suppliers. Quality checks are conducted before dispatch wherever applicable.
              </p>
            </li>
            <li>
              <strong>Do you provide invoices and GST bills?</strong>
              <p>
                Yes, proper tax invoices and GST-compliant bills are issued for all transactions.
              </p>
            </li>
            <li>
              <strong>Is my data safe on your platform?</strong>
              <p>
                Yes. We follow reasonable security practices and comply with applicable data protection laws to safeguard customer information.
              </p>
            </li>
            <li>
              <strong>How can I contact customer support?</strong>
              <p>
                For sales, support, or grievance-related queries, you can reach us through the contact details provided on{" "}
                <a href="https://www.powergroups.in" target="_blank" rel="noopener noreferrer">
                  www.powergroups.in
                </a>.
              </p>
            </li>
          </ol>
        </section>

        <p className="faq-note">
          <em>This FAQ may be updated periodically to reflect changes in services or regulations.</em>
        </p>
      </div>
    </Layout>
  );
};

export default FrequentlyAskedQuestion;